import { State } from "../types/store";

export const selectAuth = (state: State) => state.auth;

export const selectRedirectUrl = (state: State) => state.auth.redirectUrl;
export const selectRedirectUrlQueries = (state: State) => state.auth.redirectUrlQueries;
export const selectAuthUserType = (state: State) => state.auth.userType;
export const selectAuthLoading = (state: State) => state.auth.isLoading;
export const selectAuthUser = (state: State) => state.auth.user;
export const selectAuthErrors = (state: State) => state.auth.errors;
export const selectIsOAuth = (state: State) => state.auth.isOAuth;
